import SelectionView from './SelectionView';

export default SelectionView;
